import type { ContentEntity } from "shared/schema";
import type { AtTag } from "shared/util/tag";
import type { AbsolutePath } from "shelving";
import { getURL } from "shelving";
import { CopyButton, PathButton } from "shared/react";
import { CreatorCondition } from "../create/CreatorCondition.js";
import { useCreatorItem } from "../util/data.js";
import { useItem } from "../util/db.js";

export function RewardMenu({ id }: { id: string }): React.ReactElement | null {
	const { creator, slug, type } = useItem("reward", id).data;
	const username = useCreatorItem(creator).value?.username;
	const entity: ContentEntity | AtTag = username ? `@${username}/${slug}` : `reward:${id}`;
	const path: AbsolutePath = username ? `/${username}/${slug}` : `/reward/${id}`;
	return (
		<>
			<CreatorCondition creator={creator}>
				<nav className="flex-column gap-hairline">
					<PathButton path={`/reward/${id}/edit`}>{`Edit ${type}`}</PathButton>
				</nav>
			</CreatorCondition>
			<nav className="flex-row flex-stretch gap-hairline">
				<CopyButton copy={entity}>Copy tag</CopyButton>
				<CopyButton copy={getURL(path).href}>Copy link</CopyButton>
			</nav>
		</>
	);
}
